/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { GROUND_MOTION_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';

const groundMotionIsUploadMethod = method => method !== GROUND_MOTION_METHOD_VALUES.USGS;

export default groundMotionIsUploadMethod;
